import { render, staticRenderFns } from "./Addons.vue?vue&type=template&id=aedb0ac2&scoped=true"
import script from "./Addons.vue?vue&type=script&lang=js"
export * from "./Addons.vue?vue&type=script&lang=js"
import style0 from "./Addons.vue?vue&type=style&index=0&id=aedb0ac2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aedb0ac2",
  null
  
)

export default component.exports